import React from "react";

const NavItem = ({
  icon,
  title,
  path,
  navigateTo,
  active = false,
  show = true,
}) => {
  if (!show) return null;
  return (
    <li onClick={() => navigateTo(path)} className="font-QSemiBold">
      <span
        className={`flex items-center p-3 rounded-lg transition-all duration-200 ${
          active
            ? "bg-blue-50 text-indigo-600 font-medium"
            : "text-gray-600 hover:bg-gray-100 hover:text-gray-900"
        }`}
      >
        <span
          className={`text-lg mr-3 ${
            active ? "text-indigo-600" : "text-gray-500"
          }`}
        >
          {icon}
        </span>
        <span>{title}</span>
        {active && (
          <span className="ml-auto w-1 h-6 bg-indigo-600 rounded-full"></span>
        )}
      </span>
    </li>
  );
};

export default NavItem;
